import styled, { css } from 'styled-components';
import QuizCategoryComponent from './QuizCategory';

type WrapperProps = {
  noBorder?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 20px 24px;
  border-radius: 16px;
  ${props =>
    !props.noBorder &&
    css`
      border: 1px solid #cfd8dc;
    `};
`;

export const Title = styled.span`
  text-align: center;
  width: 100%;
  margin-bottom: 14px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 120%;
  text-align: center;
  letter-spacing: 0.0075em;
  color: #263238;
`;

export const QuizsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 8px 10px 0;
  justify-content: space-between;
`;

export const QuizCategory = styled(QuizCategoryComponent)`
  margin: 8px 0;
`;
